// extracted by mini-css-extract-plugin
module.exports = {"payment-details":"PaymentDetails_payment-details__2VspR"};